import React from 'react';
import { ActiveCheckinSummary } from '../checkins/ActiveCheckinSummary';
import { Reporting } from '../common/Reporting';
import { Logo } from '../common/Logo';
import { SiteStyle } from '../common/SiteStyle';
import { CheckoutButton } from '../common/CheckoutButton';
import { Spacer } from '../common/Spacer';
import { VisitorHeader } from '../common/VisitorHeader';
import { FetchSiteState } from '../common/FetchSiteState';
import { WhenReady } from '../common/WhenReady';

export const CheckedIn = () => {

    return (
        <>
            <FetchSiteState />
            <SiteStyle />
            <Reporting />
            <WhenReady>
                <div>
                    <Spacer height='2em' />
                    <VisitorHeader />
                    <Spacer height='4em' />
                    <ActiveCheckinSummary durationSuffix='ago' />
                    <CheckoutButton />
                    <Spacer height='6em' />
                    <Logo />
                </div>
            </WhenReady>
        </>
    );
}
